import { render, staticRenderFns } from "./GoogleTranslatorWidget.vue?vue&type=template&id=e35bc6a8&scoped=true&"
import script from "./GoogleTranslatorWidget.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslatorWidget.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTranslatorWidget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoogleTranslatorWidget.vue?vue&type=style&index=1&id=e35bc6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35bc6a8",
  null
  
)

export default component.exports